export default "__VITE_ASSET__BagsYndc__"